import * as request from '@/utils/request'

const PREFIX_SHIFT = '/attendance_shift'
const PREFIX_GROUP = '/attendance_group'
const PREFIX_WORK_SHIFT = '/work_shift'
const PREFIX_CHECK_IN = '/check_in'

export default {
  // 班次列表
  getShiftList(data) {
    return request.post(`${PREFIX_SHIFT}/list`, data)
  },
  // 新增班次
  createShift(data) {
    return request.post(`${PREFIX_SHIFT}/create`, data)
  },
  // 编辑班次
  updateShift(data) {
    return request.post(`${PREFIX_SHIFT}/update`, data)
  },
  // 保存班次（无 id 调 create，有 id 调 update）
  saveShift(data) {
    if (data && data.id) {
      return request.post(`${PREFIX_SHIFT}/update`, data)
    }
    return request.post(`${PREFIX_SHIFT}/create`, data)
  },
  // 班次详情（查看）
  getShiftInfo(id) {
    return request.post(`${PREFIX_SHIFT}/view`, { id })
  },
  // 班次编辑详情（编辑页用，readonly=false）
  getShiftEditView(id) {
    return request.post(`${PREFIX_SHIFT}/edit_view`, { id })
  },
  // 删除班次
  deleteShift(id) {
    return request.post(`${PREFIX_SHIFT}/delete`, { id })
  },
  // 班次状态切换
  updateShiftStatus(data) {
    return request.post(`${PREFIX_SHIFT}/status`, data)
  },

  // 打卡组列表
  getAttendanceGroupList(data) {
    return request.post(`${PREFIX_GROUP}/list`, data)
  },
  // 新增打卡组
  createAttendanceGroup(data) {
    return request.post(`${PREFIX_GROUP}/create`, data)
  },
  // 编辑打卡组
  updateAttendanceGroup(data) {
    return request.post(`${PREFIX_GROUP}/update`, data)
  },
  // 保存打卡组（无 id 调 create，有 id 调 update）
  saveAttendanceGroup(data) {
    if (data && data.id) {
      return request.post(`${PREFIX_GROUP}/update`, data)
    }
    return request.post(`${PREFIX_GROUP}/create`, data)
  },
  // 打卡组详情（查看）
  getAttendanceGroupInfo(id) {
    return request.post(`${PREFIX_GROUP}/view`, { id })
  },
  // 打卡组编辑详情（编辑页用）
  getAttendanceGroupEditView(id) {
    return request.post(`${PREFIX_GROUP}/edit_view`, { id })
  },
  // 删除打卡组
  deleteAttendanceGroup(id) {
    return request.post(`${PREFIX_GROUP}/delete`, { id })
  },
  // 打卡组状态切换
  updateAttendanceGroupStatus(data) {
    return request.post(`${PREFIX_GROUP}/status`, data)
  },
  // 任务可选项（打卡组绑定任务时下拉）
  getAttendanceGroupTaskOptions(data = {}) {
    return request.post(`${PREFIX_GROUP}/task_options`, data)
  },
  // 班次可选项（打卡组绑定班次时下拉）
  getAttendanceGroupShiftOptions(data = {}) {
    return request.post(`${PREFIX_GROUP}/shift_options`, data)
  },
  /** 任务打卡列表 / 导出（见 attendance-api.md §2.1 / §2.2） */
  checkInTaskList(data) {
    return request.post(`${PREFIX_CHECK_IN}/task/list`, data)
  },
  checkInTaskExport(data) {
    return request.post(`${PREFIX_CHECK_IN}/task/export`, data)
  },
  checkInStatsList(data) {
    return request.post(`${PREFIX_CHECK_IN}/stats/list`, data)
  },
  checkInStatsExport(data) {
    return request.post(`${PREFIX_CHECK_IN}/stats/export`, data)
  },
  /** 个人打卡统计（按月每日明细），见 §2.5 */
  checkInStatsPersonal(data) {
    return request.post(`${PREFIX_CHECK_IN}/stats/personal`, data)
  },

  /** 考勤班次 work_shift（见 src/pages/scheduling/attendance-api.md） */
  workShiftList(data) {
    return request.post(`${PREFIX_WORK_SHIFT}/list`, data)
  },
  workShiftStore(data) {
    return request.post(`${PREFIX_WORK_SHIFT}/store`, data)
  },
  workShiftView(id) {
    return request.post(`${PREFIX_WORK_SHIFT}/view/${id}`)
  },
  workShiftDelete(id) {
    return request.post(`${PREFIX_WORK_SHIFT}/delete/${id}`)
  },
  workShiftMissionList(data) {
    return request.post(`${PREFIX_WORK_SHIFT}/mission/list`, data)
  },
  workShiftChangeStatus(data) {
    return request.post(`${PREFIX_WORK_SHIFT}/change_status`, data)
  },
  /** 为班次增量关联任务（不覆盖已有绑定） */
  workShiftBindMissions(data) {
    return request.post(`${PREFIX_WORK_SHIFT}/bindMissions`, data)
  },


   // 查看简历详情
   resumeView(data) {
    return request.post("/resume/view", data);
  },
}
